import React from 'react';

const SmartObjectiveIcon = function SmartObjectiveIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
      <path d="M14.0961 0V7.52217H12.2628V18.7431H11.0406V11.2625H6.15177V18.7431H4.92956V13.756H1.26295V18.7431H0V19.9898H18.3738V18.7431H17.1516V7.52217H15.3183V3.7403H20.859L18.3738 1.87015L20.859 0H14.0961Z" fill="#001760" />
      <rect y="18.75" width="18.4" height="1.4" fill="#1EC252" />
    </svg>
  );
};
export default SmartObjectiveIcon;
